
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(148|558|584|745)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
